<template>
  <el-dialog
    :title="$t('text.edit_roles') + ' (' + user.UserName + ')'"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()"
    width="670px"
    class="edit-roles"
  >
    <div>
      <el-transfer
        v-model="value"
        :data="roles"
        :titles="titles"
        :props="{
          key: 'Id',
          label: 'RoleName'
        }"
      ></el-transfer>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="save-btn min-w-80"
        @click="update()"
        :loading="loading"
        >{{ $t('text.save').toUpperCase() }}</el-button
      >
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/CommonApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dialogVisible: false,
      user: {},
      titles: [this.$t('text.available_roles'), this.$t('text.assigned_roles')],
      roles: [],
      value: [],
      loading: false
    }
  },
  mounted() {
    this.getRoles()
  },
  watch: {
    user() {
      this.value = this.user.UserRoles.map(item => {
        return item.Id
      })
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
    },
    getRoles() {
      ApiService.GetRoles().then(response => {
        if (response.data.success) {
          this.roles = response.data.data
        } else {
          // swal({
          //   icon: 'error',
          //   timer: 2000,
          //   title: 'Failed',
          //   text: response.data.msg
          // })
        }
      })
      // .catch(() => {
      //   swal({
      //     icon: 'error',
      //     timer: 2000,
      //     title: 'Failed'
      //   })
      // })
    },
    update() {
      this.loading = true
      ApiService.UpdateUserRole(this.user.UserId, this.value)
        .then(response => {
          this.loading = false
          if (response.data.success) {
            swal({
              icon: 'success',
              title: this.$t('text.saved_successfully'),
              timer: 2000
            })
            this.$parent.getUserList()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              text: response.data.msg
            })
          }
          this.closeDialog()
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000
          })
          this.closeDialog()
        })
    }
  }
}
</script>
